import { getEnvironmentVariable } from 'shared/utils/env';
import packageJson from '../../../package.json';

export const PRODUCTION_ENVIRONMENT_NAME = 'PRODUCTION';
export const DEV_ENVIRONMENT_NAME = 'DEV';

export const DEV_API_URL = 'https://dev-api.vpluse.me';

export const BASE_URL = getEnvironmentVariable('REACT_APP_BASE_URL') || DEV_API_URL;
export const ENVIRONMENT = getEnvironmentVariable('REACT_APP_ENV') || DEV_ENVIRONMENT_NAME;

export const APP_VERSION = packageJson.version;
